module.exports = __webpack_public_path__ + "img/step17_a_remove_endcaps-talaria.75c54896.png";